import React from 'react'
import { styled } from '@mui/material'

const Backdrop = styled('div')({
    position: 'fixed',
    inset: 0,
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    fontFamily:
        '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif',
})

const AlertBox = styled('div')({
    width: 270,
    maxWidth: '85%',
    borderRadius: 14,
    padding: '20px 16px 16px',
    backgroundColor: 'rgba(245, 245, 245, 0.7)',
    backdropFilter: 'blur(40px) saturate(180%)',
    WebkitBackdropFilter: 'blur(40px) saturate(180%)',
    color: '#000',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.18)',
})

const TitleArea = styled('div')({
    padding: '0 8px 16px',
    textAlign: 'left',
    fontSize: 17,
    fontWeight: 500,
    lineHeight: 1.3,
    letterSpacing: '-0.24px',
})

const ButtonRow = styled('div')({
    display: 'flex',
    gap: 8,
})

const AlertButton = styled('button')({
    flex: 1,
    border: 'none',
    borderRadius: 14,
    padding: '11px 8px',
    fontSize: '1.0625rem',
    fontWeight: 400,
    color: '#000',
    backgroundColor: 'rgba(118, 118, 128, 0.16)',
    cursor: 'pointer',
    fontFamily: 'inherit',
    letterSpacing: '-0.41px',
    '&:active': {
        backgroundColor: 'rgba(118, 118, 128, 0.32)',
    },
})

function MotionPermissionDialog({ onCancel, onContinue }) {
    return (
        <Backdrop role="alertdialog" aria-modal="true">
            <AlertBox>
                <TitleArea>
                    This Augmented Reality Experience Requires Access Permission
                </TitleArea>
                <ButtonRow>
                    <AlertButton onClick={onCancel}>Cancel</AlertButton>
                    <AlertButton onClick={onContinue}>Continue</AlertButton>
                </ButtonRow>
            </AlertBox>
        </Backdrop>
    )
}

export { MotionPermissionDialog }
